export default {
	and_more_dates_plural: 'Y {dates} fechas más',
	and_more_dates: 'Y {dates} fecha más',
	attend_this_face_to_face_class_at_the_address_indicated:
		'Asiste a esta clase presencial en la dirección indicada',
	awaiting_results: 'Esperando resultados',
	canceled: 'Cancelado',
	check_your_availability_at_all_times_before_confirming_your_presence:
		'Verifique su disponibilidad en todo momento antes de confirmar su presencia.',
	class_date: 'Fecha de clase',
	closed: 'Solo invitados',
	do_you_confirm_your_registration_for_the_presential_class:
		'¿Confirma su registro para la clase presencial {title}?',
	do_you_confirm_your_unsubscription_to_the_presential_class: '¿Desea cancelar la inscripción?',
	end_time: 'Hora de finalización',
	event_type: 'Tipo de evento',
	finished: 'Terminado | Terminados',
	in_progress: 'En progreso',
	intermission: 'Intervalo',
	live: 'En vivo',
	loading_presential_classes: 'Cargando clases presenciales',
	model: 'Modelo',
	next: 'Próximo',
	no_presential_classes_are_available_at_the_moment:
		'Actualmente no hay clases presenciales disponibles',
	no_presential_classes_are_available_with_the_selected_filter:
		'No hay clases presenciales disponibles para el filtro seleccionado.',
	opened: 'Abierto',
	please_wait_for_instructor_presence_check: 'Espere la validación del instructor',
	pre_scheduled: 'Pre programado',
	presential_class_offline: 'Clase presencial sin conexión',
	presential_event: 'Clase presencial',
	receive_emails_about_this_presential_class:
		'Reciba correos electrónicos sobre esta clase presencial',
	register_for_the_presential_class: 'Regístrese para la clase presencial',
	reproved: 'Reprobado',
	scheduled: 'Programado',
	start_time: 'Hora de inicio',
	subscribe: 'Registrarse',
	subscribed: 'Registrado',
	successfully_signed_up_for_the_presential_class: 'Se inscribió con éxito en la clase presencial',
	this_class_has_already_ended_finish_the_rest_of_the_days_activities:
		'Esta clase ya terminó. Termina el resto de actividades del día.',
	this_class_has_already_ended: 'Esta clase ya terminó.',
	transmission_date: 'Fecha de transmisión',
	transmission_finished: 'Transmisión terminada',
	unsubscribe_from_the_presential_class: 'Cancelar inscripción',
	unsubscribe_successfully_for_the_presential_class:
		'Cancelar inscripción con éxito para la clase presencial',
	unsubscribe: 'Cancelar inscripción',
	you_already_have_a_certificate_for_this_type_of_event:
		'Ya tienes certificado para este tipo de evento',
	your_presential_class_will_start_soon_please_wait:
		'Su clase presencial comenzará pronto, por favor espere',
}
